import { IAppState } from "../../../app/appTypes"
import { IUserMessageState } from "../../../features/userMessage/state/userMessageTypes"

export const getUserMessage = (state: IAppState): IUserMessageState => state.userMessage
